<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <p :class="{'control': true, 'is-loading': inProgress}">
            <label class="label">Booking <p style="color: red;">(CANGOOROO BOOKINGS ONLY)</p></label>
            <input :class="{'input': true, 'is-danger': errors.has('booking'), 'is-disabled': inProgress}" name="booking" id="booking" type="text" placeholder="Booking" v-model="booking" v-validate data-vv-rules="required|numeric">
            <span v-show="errors.has('booking')" class="help is-danger">{{ errors.first('booking') }}</span>
          </p>
        </div>
        <div class="panel" v-if="services.hasOwnProperty('new') || services.hasOwnProperty('old')">
          <p class="panel-heading">Imported Services of Booking #{{ booking }}</p>
          <p class="panel-block" v-for="service in services.new">#{{ service.service_id }} - {{ service.service_date }} - {{ service.service_status }} (new)</p>
          <p class="panel-block" v-for="service in services.old">#{{ service.service_id }} - {{ service.service_date }} - {{ service.service_status }} (exist)</p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress}" @click="close">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-warning': true, 'is-disabled': inProgress}" @click="clear">Clear</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="importBooking">Import</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        title: 'Import Booking',
        booking: '',
        services: [],
        error: '',
        inProgress: false
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      close () {
        this.$el.remove()
      },
      importBooking () {
        this.$validator.validateAll()
        if (this.$validator.errorBag.errors.length === 0) {
          this.inProgress = true
          this.error = ''
          this.context.$http.post(this.context.$store.state.config.apiURL + '/services/import', {booking_id: this.booking}).then((response) => {
            this.inProgress = false
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.error
            } else {
              this.services = response.body
            }
          }, (response) => {
            this.inProgress = false
            this.error = response.body.error
          })
        }
      },
      clear () {
        this.error = ''
        this.inProgress = false
        this.booking = ''
        this.services = []
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Import.vue?0677f086